import React, { useState, useRef, useEffect } from "react";
import { KBD } from "../../utils/Keybindings";
import { listen } from "../../hooks/Listener";
import Input from "../../ui/Input";
import Cookies from 'js-cookie';
import Label from "../../ui/Label";
import Card from "../../ui/Card";
import Button from "../../ui/Button";
import Float from "../../ui/Float";
import { apiCall } from "../../utils/Api";
import { showError } from "../../ui/Message";
import { kbdEvent } from "../../utils/Utils";
import { ROUTES } from "../../utils/Routes";
import Login from "./Login";
import Stores from "./Stores";
import logo from "../../media/logo.png";
import Spin from "../../ui/Spin";

export default function Authentication(props) {

    const { controller = "", status = "", setStatus = () => { } } = props;

    const route = ROUTES.AUTHENTICATION.LOGIN;
    const path = window.location.pathname;
    const path_id = path.split("/")[1];
    const work_station_id = path.split("/")[2] ?? null;
    // setting as undefined so it doesn't trigger a state update
    const [session, setSession] = useState(undefined);
    const [loading, setLoading] = useState(true);
    const [state, setState] = useState("checking");
    const connectingRef = useRef(false);

    const continueToBMO = (_corp_id, _store_name) => {
        if (connectingRef.current) return;
        connectingRef.current = true;
        setState("connecting");
        setLoading(true);
        window.can_call = true;
        apiCall("account/bizToBmo", { store_id: 298, corp_id: _corp_id }, (_s, _r) => {
            if (_s) {
                window.credentials = {
                    socket_url: "wss://" + _r.url + "/ws/",
                    ticket: _r.ticket,
                    store_id: _corp_id,
                    work_station_id: work_station_id,
                }
                if (work_station_id !== null) {
                    window.history.replaceState(null, '', '/' + _corp_id.toString() + "/" + work_station_id);
                } else {
                    window.history.replaceState(null, '', '/' + _corp_id.toString());
                }
                setStatus("connecting")
            } else {
                connectingRef.current = false;
                showError(_r);
                setState("stores");
            }
            setLoading(false);
        })
    }



    const getSession = () => {
        setLoading(true);
        let _obj = {};
        if (Cookies.get("bmo_session_id")) {
            _obj.session_id = Cookies.get("bmo_session_id");
        }
        apiCall("session/get", _obj, (_s, _r) => {
            if (_s) {
                window.sitesettings = _r;
                window.store_id = _r.store_id;
                Cookies.set("bmo_session_id", _r.session_id, { expires: 14 });
                setSession(_r);

                apiCall("store/getSettings", { session_id: _r.session_id, store_id: _r.store_id }, (_success, _result) => {
                    if (_success) {
                        window.customer_url = _result.url;
                    }
                })


            } else {
                showError(_r);
            }
            setLoading(false);
        })
    }

    useEffect(getSession, []);




    const checkSession = () => {


        if (session === undefined) {
            return;
        }

        window.login_session = session;

        // Session was checked and none exists.
        if (session === null) {
            window.bm_state.value = ROUTES.AUTHENTICATION.LOGIN;
            setState("login");
            setLoading(false);
            return;
        }

        if (!session.logged_in) {
            window.bm_state.value = ROUTES.AUTHENTICATION.LOGIN;
            setState("login");
            setLoading(false);
            return;
        }

        // No possible stores
        if (session.available_corps.filter(item => item.can_bmo).length === 0) {
            showError({ error: "BMO is not currently activated on your account.  Please contact Bookmanager Support to activate." })
            return;
        }

        // Bypass with path id
        if (path_id && session.available_corps.filter(item => item.can_bmo).find(item => item.id.toString() === path_id.toString())) {
            continueToBMO(path_id, session.store_name);
            return;
        }

        else {
            if (path_id) {
                showError({ error: "No store with Bookmanager Online access is linked to this account." });
            }
        }

        // If there is only one store, skip store selection
        if (session.available_corps.filter(item => item.can_bmo).length === 1) {
            let _f = session.available_corps.find(item => item.can_bmo);
            continueToBMO(_f.id, session.store_name);
            return;
        }

        window.bm_state.value = ROUTES.AUTHENTICATION.STORES;
        setState("stores")




    }

    useEffect(checkSession, [session])


    const logout = (_store_id = session.store_id) => {
        setLoading(true);
        apiCall("account/logout", { store_id: _store_id }, (_s, _r) => {
            if (_s) {
                setSession(_r);
                setState("login")
                window.bm_state.value = ROUTES.AUTHENTICATION.LOGIN;
            } else {
                showError(_r);
            }
            setLoading(false);
        })
    }

    if (state === "checking") {
        return (<></>)
    }

    if (state === "connecting") {
        return (

            <Card style={{ padding: "8px", minWidth: "120px", minHeight: "30px", "textAlign" : "center" }}>
                <div><img style={{ "height": "30px" }} src={logo} /></div>
                <div className="shim" />
                <small><small>Connecting...</small></small>
            </Card>

        );
    }



    return (
        <Spin loading={loading}>
            <Card style={{ "padding": "10px" }}>
                {(state === "login" && <Login
                    controller={controller}
                    loading={loading} setLoading={setLoading}
                    state={state} setState={setState}
                    session={session} setSession={setSession}
                    route={ROUTES.AUTHENTICATION.LOGIN}
                />)}
                {(session && state === "stores" && <Stores
                    controller={controller}
                    loading={loading} setLoading={setLoading}
                    state={state} setState={setState}
                    session={session} setSession={setSession}
                    route={ROUTES.AUTHENTICATION.STORES}
                    continueToBMO={continueToBMO}
                    logout={logout}
                />)}
            </Card>
        </Spin>
    )
}